const Logo = () => {
    return (
        <img
            className="SvgLogo"
            alt="DoctorProx"
            loading="lazy"
        />
    );
};

export default Logo;
